// Dedupes identical in-flight GET requests (concurrent, e.g. React StrictMode
// double-mount effects or two components fetching the same resource) and serves
// short-lived cached results for sequential repeats. Keyed by URL so only truly
// identical calls share a single round trip.
const inflight = new Map();
const resultCache = new Map();
const DEFAULT_TTL = 2000; // ms

export async function dedupeFetch(url, options = {}, ttl = DEFAULT_TTL) {
  // Sequential repeat within TTL: reuse the resolved payload.
  const cached = resultCache.get(url);
  if (cached && Date.now() - cached.at < ttl) return cached.data;

  // Concurrent duplicate: join the in-flight request instead of a new fetch.
  if (inflight.has(url)) return inflight.get(url);

  const request = (async () => {
    const response = await fetch(url, options);
    if (!response.ok) throw new Error(`Request failed: ${response.status}`);
    const data = await response.json();
    resultCache.set(url, { at: Date.now(), data });
    return data;
  })();

  inflight.set(url, request);
  try {
    return await request;
  } finally {
    inflight.delete(url);
  }
}
